import type RootState from 'app-components/utils/redux-store/rootState';

import { CREDIT_PROFILE_REDUCER_KEY } from './types';

type State = Pick<RootState, typeof CREDIT_PROFILE_REDUCER_KEY>;

export const getCreditProfileStore = (state: State) => state[CREDIT_PROFILE_REDUCER_KEY];
export const getLoadPending = (state: State) => getCreditProfileStore(state).loadPending;
export const getIsLoading = (state: State) => getCreditProfileStore(state).isLoading;
export const getError = (state: State) => getCreditProfileStore(state).error;
export const getResourcesById = (state: State) => getCreditProfileStore(state).resourcesById;
export const getCreditProfile = (state: State) => {
  const resourcesById = getCreditProfileStore(state).resourcesById;
  const creditReportReceived = resourcesById.find((profile) => profile?.status === 'CREDIT_REPORT_RECEIVED');
  return creditReportReceived || resourcesById.first();
};

export const getIsPolling = (state: State) => getCreditProfileStore(state).isPolling;
export const getIsRetryLoading = (state: State) => getCreditProfileStore(state).isRetryLoading;
export const getIsContinuing = (state: State) => getCreditProfileStore(state).isContinuing;
export const getLastRetryDate = (state: State) => getCreditProfileStore(state).lastRetryDate;
